import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useErrorBoundary } from "react-error-boundary";
import { addTenant, updateTenant } from "./AdminListApi";
import { callApi, handleErrorAdmin } from "../common/api/Api";

export type TenantForm = {
  companyName: string;
  useCategory: string;
  country: string;
  givenName: string;
  familyName: string;
  emailAddress: string;
  contractType: string;
  state?: string;
};

const defaultTenantForm: TenantForm = {
  companyName: "",
  useCategory: "customer",
  country: "",
  givenName: "",
  familyName: "",
  emailAddress: "",
  contractType: "ricoh",
  state: "",
};

export const useRegisterTenantButton = (
  targetCustomerTenantId: string | undefined,
  targetContractorId: string | undefined,
  onAfterRegisterFunc: { (): void },
) => {
  const { t } = useTranslation();
  const { showBoundary } = useErrorBoundary();
  const [inputDialogOpen, setInputDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const [tenantFormData, setTenantFormData] = useState<TenantForm>(defaultTenantForm);

  const onClick = () => {
    setInputDialogOpen(true);
    setTenantFormData(defaultTenantForm);
  };

  const onConfirm = (form: TenantForm) => {
    setTenantFormData(form);
    setInputDialogOpen(false);
    setConfirmDialogOpen(true);
  };

  const onInputCancel = () => {
    setInputDialogOpen(false);
  };

  const onRegister = () => {
    (async () => {
      await callApi(async () => {
        if (!targetCustomerTenantId || !targetContractorId) {
          // 新規テナントの登録の場合
          const result = await addTenant(tenantFormData);
          if (result.error) {
            return handleErrorAdmin(result.error?.response?.data, result.error, showBoundary, t);
          }
          if (!result.data) {
            return;
          }
        } else {
          // 既存テナントの変更の場合
          const result = await updateTenant(targetCustomerTenantId, targetContractorId, tenantFormData);
          if (result.error) {
            return handleErrorAdmin(result.error?.response?.data, result.error, showBoundary, t);
          }
          if (!result.data) {
            return;
          }
        }
        onAfterRegisterFunc();
      });
    })();

    setInputDialogOpen(false);
    setConfirmDialogOpen(false);
  };

  const onConfirmCancel = () => {
    setConfirmDialogOpen(false);
    setInputDialogOpen(true);
  };

  return {
    inputDialogOpen,
    confirmDialogOpen,
    tenantFormData,
    onClick,
    onConfirm,
    onInputCancel,
    onRegister,
    onConfirmCancel,
  };
};
